import ColorIconButton from 'components/color-icon-button';
import ColorPickerPopover, { ColorValuesMap } from 'components/color-picker-popover';
import DefaultColorPopoverInput from 'components/default-color-popover-input';
import { useState } from 'react';
import t from 'react-translate';
import _ from 'underscore';
import { LectureComponentProps } from '..';
import { config } from '../../../../config/config.json';

/** Wraps the ColorPickerPopover for use in a web link lecture component text area.  */
const WebLinkColorPickerPopover = (props: {
  currentLecture: LectureComponentProps['currentLecture'],
  colorValues: ColorValuesMap,
  inputLabels: Record<string, string>,
}) => {
  const [showColorPicker, setShowColorPicker] = useState(false);

  return (
    <ColorPickerPopover
      show={showColorPicker}
      placement='top-end'
      currentLecture={props.currentLecture}
      renderContent={({ getColorInputProps }) => (
        <div>
          {_.keys(props.colorValues).map((key, i) => (
            <div key={key} className={i === 0 ? 'mb-4' : ''}>
              <DefaultColorPopoverInput
                name={key}
                getColorInputProps={getColorInputProps}
                label={props.inputLabels[key]}
              />
            </div>
          ))}
        </div>
      )}
      colorValues={props.colorValues}
      onToggle={(nextShow) => { setShowColorPicker(nextShow); }}
    >
      <div className={`icon-btn-container ${showColorPicker ? 'picker-visible' : ''}`}>
        <ColorIconButton tooltip={!showColorPicker && t.LECTURE_PAGES.COMPONENTS.WEB_LINK.EDIT_COLORS()} data-qa={config.pendo.activities.webLink.textColorPicker} />
      </div>
    </ColorPickerPopover>
  );
};

export default WebLinkColorPickerPopover;
